<script lang="ts">
	import { untrack } from 'svelte';
	import Grid from './Grid.svelte';
	import TravelingCircle from './TravelingCircle.svelte';

	let strokeWidth = $state(1);

	let width = $state(200);
	let height = $state(200);

	let tilesX = 5;
	let tilesY = 5;

	let tileWidth = $derived((width - strokeWidth) / tilesX);
	let tileHeight = $derived((height - strokeWidth) / tilesY);
	let ref: SVGGElement | null = $state(null);
	let path = $state([{ x: 0, y: 0 }]);

	const smallestSize = $derived(Math.min(tileWidth, tileHeight));
	const margin = $derived(0.3 * smallestSize * 0.5);
	const r = $derived(smallestSize * 0.5 - margin);

	const steps = $derived.by(() => {
		const result = [];
		for (let i = 0; i < tilesY; i++) {
			result.push(tileHeight * i + tileHeight / 2);
		}
		return result;
	});

	const circs = $derived.by(() => {
		const result = [];
		for (let i = 0; i < tilesX; i++) {
			result.push(i * tileWidth + tileWidth / 2);
		}
		return result;
	});

	let animationFrame: number;

	function lineLoop() {
		animationFrame = requestAnimationFrame(lineLoop);
		if (!ref) return;
		const circles = ref.querySelectorAll('circle');
		for (let i = 0; i < circles.length; i++) {
			const circ = circles[i];
			const x = parseFloat(circ.getAttribute('cx') || '0');
			const y = parseFloat(circ.getAttribute('cy') || '0');
			path[i] = { x, y };
		}
	}

	const svgPath = $derived.by(() => {
		return path
			.map((p, i) => {
				if (i === 0) {
					return `M ${p.x} ${p.y}`;
				} else {
					return `L ${p.x} ${p.y}`;
				}
			})
			.join('');
	});

	$effect(() => {
		if (!ref) return;
		untrack(() => lineLoop());
		return () => {
			cancelAnimationFrame(animationFrame);
		};
	});
</script>

<svg
	bind:clientWidth={width}
	bind:clientHeight={height}
	class="container"
	viewBox="0 0 {width} {height}"
>
	<Grid {tilesX} {tilesY} {width} {height}></Grid>

	<g bind:this={ref}>
		{#each circs as circ}
			<TravelingCircle x={circ} {steps} {r}></TravelingCircle>
		{/each}
	</g>

	<g>
		<path d={svgPath} stroke="#685D50" stroke-width={0.5} fill="none"></path>
	</g>
</svg>

<style lang="scss">
	.container {
		width: 100%;
		height: 100%;
	}
</style>
